@if (renderMode === 'inline' && whiteLabelService.usesInlineBetPlacement()) {
	<form
		[formGroup]="placeBetForm"
		(ngSubmit)="placeBet()"
		class="v3-place-bet v3-place-bet--inline"
		[class.v3-place-bet--full-bleed]="inlineBleed"
		[ngClass]="{ back: selectedRunner().side === 'BACK', lay: selectedRunner().side === 'LAY' }">
		<app-v3-place-bet-view
			[placeBetForm]="placeBetForm"
			[selectedRunner]="selectedRunner()"
			[sideLabel]="sideLabel(selectedRunner().side)"
			[errorMessage]="errorMessage"
			[isHandicapTypeMarket]="isHandicapTypeMarket"
			[isOddReadonly]="shouldOddBeReadonly"
			[isPlacing]="betService.isPlacingBet() || isPlacingInAnotherTab"
			[isPlaceBetDisabled]="isPlaceBetDisabled"
			[quickBetAmounts]="(editStakeModalService.quickBetAmounts$ | async) ?? []"
			[showMinMaxStakeButtons]="showMinMaxStakeButtons"
			[minStake]="minBetSize()"
			[maxStake]="maxBetSize()"
			[keypadKeys]="v3KeypadKeys"
			[totalExposureDebugging]="shouldShowExposureDebugging ? getTotalExposureDebugging() : null"
			(dismiss)="closeBetPlacingWindow()"
			(decrementOdd)="decrementOddByAmount()"
			(incrementOdd)="incrementOddByAmount()"
			(decrementStake)="decrementStakeByAmount()"
			(incrementStake)="incrementStakeByAmount()"
			(setStake)="setStakeAmount($event)"
			(setLimitStake)="setLimitStake($event)"
			(applyKeypadValue)="applyV3KeypadValue($event)"
			(showDebugging)="showDebuggingAlert()" />
	</form>
} @else {
	<ion-modal
		#placeBetModal
		id="place-bet-modal"
		[isOpen]="true"
		[class.exchange-compact-modal]="whiteLabelService.isV2Skin()"
		(didDismiss)="afterModalDismissal()"
		xmlns="http://www.w3.org/1999/html">
		<ng-template>
			<form
				[formGroup]="placeBetForm"
				(ngSubmit)="placeBet()"
				class="py-3 px-2 flex flex-col gap-1 justify-start items-start w-full"
				[class.exchange-compact-place-bet]="whiteLabelService.isV2Skin()"
				[class.v3-place-bet]="!whiteLabelService.isV2Skin()"
				[ngClass]="{ back: selectedRunner().side === 'BACK', lay: selectedRunner().side === 'LAY' }">
				@if (whiteLabelService.isV2Skin()) {
					<div class="exchange-compact-place-bet__header">
						<h2>{{ 'Place Bet' | translate }}</h2>
						<button type="button" (click)="placeBetModal.dismiss()" aria-label="Close place bet modal">
							<ion-icon name="close"></ion-icon>
						</button>
					</div>

					<div class="exchange-compact-place-bet__body">
						<div class="exchange-compact-place-bet__runner-row">
							<strong>{{ selectedRunner().name }}</strong>
							<span
								>{{ (selectedRunner().side === 'BACK' ? 'Profit' : 'Liability') | translate }}:
								{{ profitOrLiability() ?? 0 | number: '1.0-2' }}</span
							>
						</div>

						<div class="exchange-compact-place-bet__field-labels">
							<span>{{ 'Odds' | translate }}</span>
							<span>{{ 'Amount' | translate }}</span>
						</div>

						<div class="exchange-compact-place-bet__inputs">
							<div class="exchange-compact-place-bet__odd-control">
								<button type="button" [disabled]="shouldOddBeReadonly" (click)="decrementOddByAmount()">
									<ion-icon name="remove"></ion-icon>
								</button>
								<input
									type="number"
									formControlName="odd"
									[placeholder]="'Odd' | translate"
									[readonly]="shouldOddBeReadonly"
									[attr.inputmode]="shouldOddBeReadonly ? 'none' : null"
									[style.pointer-events]="shouldOddBeReadonly ? 'none' : null" />
								<button type="button" [disabled]="shouldOddBeReadonly" (click)="incrementOddByAmount()">
									<ion-icon name="add"></ion-icon>
								</button>
							</div>

							<input type="number" formControlName="stake" [placeholder]="'Stake' | translate" />
						</div>

						<div class="exchange-compact-place-bet__errors">
							<div>
								@if (formControls.odd.errors) {
									<app-form-error-message [control]="formControls.odd" />
								}
							</div>
							<div>
								@if ((formControls.stake.dirty || formControls.stake.touched) && formControls.stake.errors) {
									<app-form-error-message [control]="formControls.stake" />
								}
								@if (errorMessage) {
									<span>{{ errorMessage | translate }}</span>
								}
							</div>
						</div>

						<div class="exchange-compact-place-bet__quick-stakes">
							@for (stake of editStakeModalService.quickBetAmounts$ | async; track stake) {
								<button type="button" (click)="setStakeAmount(stake)">
									{{ formatQuickAmount(stake) }}
								</button>
							}
						</div>

						@if (showMinMaxStakeButtons) {
							<div class="limit-stake-actions">
								<button type="button" class="min-stake-btn" (click)="setLimitStake(minBetSize())">{{ 'Min Bet' | translate }}</button>
								<button type="button" class="max-stake-btn" (click)="setLimitStake(maxBetSize())">{{ 'Max Bet' | translate }}</button>
							</div>
						}

						@if (isHandicapTypeMarket) {
							<div class="exchange-compact-place-bet__ladder">
								<app-ah-ladder-pnl />
							</div>
						}

						<div class="exchange-compact-place-bet__debug" *appFeatureFlag="'exposureCalculation'">
							<ion-button
								size="small"
								color="medium"
								(click)="showDebuggingAlert()"
								(keydown.enter)="showDebuggingAlert(); $event.preventDefault()"
								(keydown.space)="showDebuggingAlert(); $event.preventDefault()"
								>Debug</ion-button
							>
							<p>New Total Exposure: {{ getTotalExposureDebugging() | number: '1.0-2' }}</p>
						</div>

						<div class="exchange-compact-place-bet__actions">
							<button type="button" class="is-link" [disabled]="betService.isPlacingBet()" (click)="clearCompactStake()">
								{{ 'Clear' | translate }}
							</button>
							<button
								type="button"
								class="is-edit"
								[disabled]="betService.isPlacingBet()"
								(click)="editStakeModalService.openQuickBetAmountsEditModal()">
								{{ 'Edit' | translate }}
							</button>
							<button type="button" class="is-reset" [disabled]="betService.isPlacingBet()" (click)="resetCompactForm()">
								{{ 'Reset' | translate }}
							</button>
							<button
								type="submit"
								class="is-place"
								[disabled]="
									placeBetForm.invalid ||
									betService.isPlacingBet() ||
									isPlacingInAnotherTab ||
									insufficientBalanceError() ||
									shouldCancelUnmatchedBetsFirst()
								">
								@if (betService.isPlacingBet() || isPlacingInAnotherTab) {
									<ion-spinner />
								} @else {
									{{ 'Place Bet' | translate }}
								}
							</button>
						</div>

						@if (!isCompactFancySelection()) {
							<div class="exchange-compact-place-bet__context">
								@for (runner of getCompactRunners(); track runner.selectionId) {
									<p>
										<span>{{ runner.runnerName }}</span>
										<span class="exchange-compact-place-bet__pnl">
											@if (getCompactPlacedProfitAndLossValue(runner.selectionId) | async; as profitAndLoss) {
												<b [ngClass]="getCompactProfitAndLossClass(profitAndLoss)">{{ formatCompactProfitAndLoss(profitAndLoss) }}</b>
											}
											@if (getCompactPredictedProfitAndLossValue(runner.selectionId) | async; as predictedProfitAndLoss) {
												<b [ngClass]="getCompactProfitAndLossClass(predictedProfitAndLoss)"
													>»&nbsp;{{ formatCompactProfitAndLoss(predictedProfitAndLoss) }}</b
												>
											}
										</span>
									</p>
								}
							</div>
						}
					</div>

					<app-edit-stake-modal />
				} @else {
					<app-v3-place-bet-view
						[placeBetForm]="placeBetForm"
						[selectedRunner]="selectedRunner()"
						[sideLabel]="sideLabel(selectedRunner().side)"
						[errorMessage]="errorMessage"
						[isHandicapTypeMarket]="isHandicapTypeMarket"
						[isOddReadonly]="shouldOddBeReadonly"
						[isPlacing]="betService.isPlacingBet() || isPlacingInAnotherTab"
						[isPlaceBetDisabled]="isPlaceBetDisabled"
						[quickBetAmounts]="(editStakeModalService.quickBetAmounts$ | async) ?? []"
						[showMinMaxStakeButtons]="showMinMaxStakeButtons"
						[minStake]="minBetSize()"
						[maxStake]="maxBetSize()"
						[keypadKeys]="v3KeypadKeys"
						[totalExposureDebugging]="shouldShowExposureDebugging ? getTotalExposureDebugging() : null"
						(dismiss)="closeBetPlacingWindow()"
						(decrementOdd)="decrementOddByAmount()"
						(incrementOdd)="incrementOddByAmount()"
						(decrementStake)="decrementStakeByAmount()"
						(incrementStake)="incrementStakeByAmount()"
						(setStake)="setStakeAmount($event)"
						(setLimitStake)="setLimitStake($event)"
						(applyKeypadValue)="applyV3KeypadValue($event)"
						(showDebugging)="showDebuggingAlert()" />
				}
			</form>
		</ng-template>
	</ion-modal>
}
